import src from "IMAGE";
export default { src, width: 1963, height: 528, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAM0lEQVR42i3EMQ0AIAxFwYIAzBDCxogBJEGCDpzg7PcNHe5MUgo5FFx8PKOOhomBioWN46wBNEoMiMHFAAAAAElFTkSuQmCC"};
